import type { ReplaceableKeyValues, TitleType } from './type';
import { getTitleTestConfig } from './config';
import { useSelector } from 'react-redux';
import { useSelectedLocale } from 'src/hooks/useSelectedLocale';
import { selectPathname } from 'src/store/selectors';

export const getTestTitleFullText = (
  replaceableKeyValues: ReplaceableKeyValues,
  testTitleTemplate: string,
) => {
  let testTitleText = testTitleTemplate;

  Object.entries(replaceableKeyValues).map(
    ([replaceableKey, replaceableValue]) => {
      const regex = `\{${replaceableKey}\}`;
      if (testTitleText.match(regex)) {
        testTitleText = testTitleText.replace(regex, replaceableValue);
      }
    },
  );

  return testTitleText;
};

export const titleOverride = ({
  replaceableKeyValues,
  titleType,
  pageLocale,
  pagePathName,
}: {
  replaceableKeyValues: ReplaceableKeyValues;
  titleType: TitleType;
  pageLocale: string;
  pagePathName: string;
}) => {
  const titleTestConfig = getTitleTestConfig() || [];
  const testConfig = titleTestConfig.find(
    (config) => config.titleType === titleType,
  );

  const { testTitle: testTitleTemplate, paths } =
    testConfig?.testVariants.find(
      (testVariant) => testVariant.locale === pageLocale,
    ) || {};

  if (paths && testTitleTemplate) {
    const matched = paths.some(
      (path) =>
        encodeURI(pagePathName).toLocaleLowerCase() ===
        path.toLocaleLowerCase(),
    );

    if (matched) {
      return getTestTitleFullText(replaceableKeyValues, testTitleTemplate);
    }
  }
  return undefined;
};

export const useTitleOverride = ({
  replaceableKeyValues,
  titleType,
}: {
  replaceableKeyValues: ReplaceableKeyValues;
  titleType: TitleType;
}) => {
  const pageLocale = useSelectedLocale();
  const pagePathName = useSelector(selectPathname);

  return titleOverride({
    replaceableKeyValues,
    titleType,
    pageLocale,
    pagePathName,
  });
};
